import i18n from 'modules/core/lib/i18n'
import legalEntities from 'modules/core/store/collections/legalEntities'

import {
  INCIDENCE_STATUSES,
  inhouseStatusCopies,
  professionalsStatusCopies,
} from 'modules/payroll_bundle/lib/Incidences/Status'

const allActive = () => ({
  label: i18n.t('bookkeepers.incidence.generic_filter.all_active'),
  value: [
    INCIDENCE_STATUSES.to_do,
    INCIDENCE_STATUSES.doing,
    INCIDENCE_STATUSES.in_preparation,
  ].join(','),
})
export const legalEntitiesOptions = () => {
  const options = legalEntities.map((legalEntity) => ({
    value: legalEntity.attributes.id.toString(),
    label: legalEntity.attributes.legal_name,
  }))

  return [...options]
}
export const statusOptions = (isBookkeeperView: boolean, inHousePayroll: boolean) => {
  const result: { value: string; label: string }[] = inHousePayroll
    ? inHouseStatusOptions()
    : defaultStatusOptions(isBookkeeperView)

  return [allActive(), ...result]
}

const inHouseStatusOptions = () => {
  return Object.entries(inhouseStatusCopies()).map(([value, label]) => ({
    value,
    label,
  }))
}

const defaultStatusOptions = (isBookkeeperView: boolean) => {
  return Object.entries(professionalsStatusCopies(isBookkeeperView)).map(([value, label]) => ({
    value,
    label,
  }))
}
